var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4584 27.125V24.5417C22.4584 23.1714 21.914 21.8572 20.9451 20.8883C19.9761 19.9193 18.662 19.375 17.2917 19.375H6.95835C5.58807 19.375 4.27391 19.9193 3.30497 20.8883C2.33603 21.8572 1.79169 23.1714 1.79169 24.5417V27.125",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 14.2083C14.9785 14.2083 17.2916 11.8951 17.2916 9.04167C17.2916 6.1882 14.9785 3.875 12.125 3.875C9.27151 3.875 6.95831 6.1882 6.95831 9.04167C6.95831 11.8951 9.27151 14.2083 12.125 14.2083Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2083 27.1251V24.5417C30.2075 23.397 29.8264 22.2849 29.1251 21.3801C28.4237 20.4754 27.4417 19.8292 26.3333 19.543",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 4.04297C22.2781 4.32752 23.2631 4.97387 23.9666 5.88012C24.67 6.78636 25.0518 7.90096 25.0518 9.04818C25.0518 10.1954 24.67 11.31 23.9666 12.2162C23.2631 13.1225 22.2781 13.7688 21.1667 14.0534",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ee0f3aaacf7b0d96eeb144d4e8f36ca9.svg";
export { ForwardRef as ReactComponent };